import React, { Component } from 'react'
import intl from 'react-intl-universal'
import PropTypes from 'prop-types'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { parse } from 'query-string'
import Page from './Page'
import { simple_api_request } from '../api/simple_api_request'
import { action, observable } from 'mobx'

@observer
class ConfirmPage extends Component {
  @observable error = false
  @action set_error = (error) => this.error = error

  render () {
    const { token } = parse(this.props.location.search.substr(1))
    if (!token) {
      return (
        <Page title='Information'>
          <article className='b-info'>
            <h2 className='b-info-title'>Missed token</h2>
          </article>
        </Page>
      )
    }

    const {set_error} = this

    simple_api_request({
      method: 'GET',
      path: '/api/register/confirm?token=' + token
    })
      .then(result => {
        console.log('ConfirmPage.js - request - result:', result)

        if (!result.ok ) {
          console.log('!result.ok')
          set_error(result.data.message)
        }

        if (result.data.success) {
          this.props.history.push('/')
        }

        return result.data
      })
      .catch(error => {
        this.set_error
        console.log('ConfirmPage.js - request - error:', error)
      })

    return (
      <Page title='Information'>
        {!this.error
          ? <article className='b-info'>
              <h2 className='b-info-title'>{intl.get('Email confirmation')}...</h2>
            </article>
          : <article className='b-info'>
              <h2 className='b-info-title'>{intl.get('Not confirmed')}</h2>
              <code>{this.error.toString()}</code>
            </article>}
      </Page>
    )
  }
}

ConfirmPage.propTypes = {
  history: PropTypes.any,
  location: MobxPropTypes.objectOrObservableObject
}

export default ConfirmPage



// WEBPACK FOOTER //
// ./src/containers/ConfirmPage.js